(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/views/subscription-info.js') >= 0) return;  svs.modules.push('/components/numbergames/game/views/subscription-info.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.numbergames=_svs.numbergames||{};
_svs.numbergames.game=_svs.numbergames.game||{};
_svs.numbergames.game.templates=_svs.numbergames.game.templates||{};
svs.numbergames.game.templates.subscription_info = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<p class=\"margin-0 align-center\">\n  Prenumerationen har ingen bindningstid och betalas månadsvis med bankkort eller autogiro.\n</p>\n";
},"useData":true});
Handlebars.partials['components-numbergames-game-subscription_info'] = svs.numbergames.game.templates.subscription_info;
})(svs, Handlebars);


 })(window);